import React, { useMemo, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import CoverableIterableComponent from './CoverableIterableComponent/CoverableIterableComponent';
import metadata from './PolicyCommonCoverables.metadata.json5';
import messages from './PolicyCommonCoverables.messages';
import styles from '../PolicyCommonDetails/PolicyCommonDetails.module.scss';

function PolicyCommonCoverables(props) {
    const { policy, value: coverables } = props;
    const translator = useContext(TranslatorContext);

    const getCoverageDetails = useCallback((coverableValue) => {
        if (_.has(policy, 'coverageNotIncluded_Ext')) {
            const coverageDObject = {
                terms: [{
                    amount: 'Not included',
                    modelType: 'Limit',
                    name: ' '
                }],
                name: _.get(policy, 'coverageNotIncluded_Ext'),
                expirationDate: '',
            };
            coverableValue.map((cover) => {
                return cover.coverages.push(coverageDObject);
            });
        }
        if (_.has(policy, 'coverageIncluded_Ext')) {
            const coverageLrpObject = {
                terms: [{
                    amount: 'Included',
                    modelType: 'Limit',
                    name: ' '
                }],
                name: _.get(policy, 'coverageIncluded_Ext'),
                expirationDate: '',
            };
            coverableValue.map((cover) => {
                return cover.coverages.push(coverageLrpObject);
            });
        }
    }, [policy]);

    const policyCoverables = useMemo(() => {
        const coverableValue = _.filter(coverables, (coverable) => {
            return coverable.coverages.length > 0;
        });
        getCoverageDetails(coverableValue);
        return coverableValue;
    }, [coverables, getCoverageDetails]);

    const wcCoverage = useCallback(() => {
        const coverableName = 'workerscompensation';
        const coverableOverrides = coverables.map((coverable, index) => {
            if (coverableName === policy.offeringCode) {
                return {
                    [`wcCoverageBlock${index}`]: {
                        value: translator(messages.wcCoverageField)
                    }
                };
            }
            return {
                [`wcCoverageBlock${index}`]: {
                    visible: false
                }
            };
        });

        return Object.assign({}, ...coverableOverrides);
    }, [coverables, policy.offeringCode, translator]);

    const overrides = {
        commonCoverablesIterable: {
            data: policyCoverables
        },
        ...wcCoverage()
    };

    const resolvers = {
        resolveComponentMap: {
            coverableiterablecomponent: CoverableIterableComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(
                metadata.componentContent,
                policyCoverables,
                id,
                path,
                overrides
            );
        },
        [policyCoverables, overrides]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={policyCoverables}
            overrideProps={overrides}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            resolveValue={readValue}
        />
    );
}

PolicyCommonCoverables.propTypes = {
    policy: PropTypes.arrayOf(PropTypes.shape({})),
    value: PropTypes.arrayOf(PropTypes.shape({}))
};

PolicyCommonCoverables.defaultProps = {
    policy: {},
    value: []
};

export default PolicyCommonCoverables;
